import HomeIcon from '@mui/icons-material/Home';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { Link as RouterLink } from 'react-router-dom';


interface IBreadcrumbDetail {
    name: string,
    href: string
}

interface IBreadcrumbBar {
    current: string
    previous: IBreadcrumbDetail[]
}

export const BreadcrumbBar: React.SFC<IBreadcrumbBar> = ({

    current,
    previous,
    ...props
}: IBreadcrumbBar) => {


    return (
        <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
        >
            <Link
                underline="hover"
                sx={{ display: 'flex', alignItems: 'center' }}
                color="inherit"
                component={RouterLink}
                to="/"
            >
                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />

            </Link>

            {previous && previous.map(crumb =>
                <Link
                    key={crumb.name}
                    underline="hover"
                    color="inherit"
                    component={RouterLink}
                    to={crumb.href}>{crumb.name}</Link>)
            }

            <Typography color="text.primary">{current}</Typography>
        </Breadcrumbs>
    );
}